import { render, staticRenderFns } from "./wv-recognition-email.vue?vue&type=template&id=a2340fa0&scoped=true&"
import script from "./wv-recognition-email.vue?vue&type=script&lang=js&"
export * from "./wv-recognition-email.vue?vue&type=script&lang=js&"
import style0 from "./wv-recognition-email.vue?vue&type=style&index=0&id=a2340fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2340fa0",
  null
  
)

export default component.exports